/* NINEPADEL chrome: mega menu (hover + click + keyboard, scrim), mobile menu drawer, predictive search dropdown, basket count. */
(function(){
  var NP = window.NP = window.NP || {};
  var hdr = document.querySelector('[data-np-hdr]');
  if(!hdr) return;
  var canHover = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  /* ---------------- mega menu ---------------- */
  var btns = [].slice.call(hdr.querySelectorAll('.nb[data-menu]'));
  var panels = [].slice.call(hdr.querySelectorAll('.panel[data-panel]'));
  var scrim = document.querySelector('[data-np-scrim]');
  var cur = null, t;
  function openMenu(k){
    cur = k;
    panels.forEach(function(p){ p.classList.toggle('on', p.dataset.panel === k); });
    btns.forEach(function(b){ b.setAttribute('aria-expanded', b.dataset.menu === k ? 'true' : 'false'); });
    document.body.classList.toggle('menu-open', !!k);
    if(k) closeDrop();
  }
  function btnFor(k){ return hdr.querySelector('.nb[data-menu="'+k+'"]'); }
  function panelFor(k){ return hdr.querySelector('.panel[data-panel="'+k+'"]'); }
  btns.forEach(function(b){
    if(canHover){
      b.addEventListener('mouseenter', function(){ clearTimeout(t); t = setTimeout(function(){ openMenu(b.dataset.menu); }, 90); });
    }
    b.addEventListener('click', function(){ clearTimeout(t); openMenu(cur === b.dataset.menu ? null : b.dataset.menu); });
    b.addEventListener('keydown', function(e){
      if(e.key === 'ArrowDown'){
        e.preventDefault(); openMenu(b.dataset.menu);
        var p = panelFor(b.dataset.menu), first = p && p.querySelector('a');
        if(first) setTimeout(function(){ first.focus(); }, 30);
      }
    });
  });
  if(canHover){
    hdr.addEventListener('mouseleave', function(){ if(!cur) return; clearTimeout(t); t = setTimeout(function(){ openMenu(null); }, 220); });
    hdr.addEventListener('mouseenter', function(){ clearTimeout(t); });
    [].slice.call(hdr.querySelectorAll('.navx a.nb')).forEach(function(a){
      a.addEventListener('mouseenter', function(){ clearTimeout(t); t = setTimeout(function(){ openMenu(null); }, 90); });
    });
  }
  if(scrim) scrim.addEventListener('click', function(){ openMenu(null); });
  /* close when keyboard focus leaves the header */
  hdr.addEventListener('focusout', function(e){
    if(cur && e.relatedTarget && !hdr.contains(e.relatedTarget)) openMenu(null);
  });

  /* ---------------- mobile menu ---------------- */
  var mdr = document.querySelector('[data-np-mdr]');
  var burger = hdr.querySelector('[data-np-burger]');
  function mOpen(on){
    if(!mdr) return;
    mdr.classList.toggle('on', on);
    document.body.classList.toggle('np-lock', on);
    document.body.classList.toggle('np-mopen', on);
    if(burger) burger.setAttribute('aria-expanded', on ? 'true' : 'false');
    if(on){ var c = mdr.querySelector('[data-np-mdr-close].iconbtn'); if(c) setTimeout(function(){ c.focus(); }, 60); }
    else if(burger) burger.focus();
  }
  if(burger) burger.addEventListener('click', function(){ mOpen(true); });
  if(mdr){
    mdr.addEventListener('click', function(e){
      if(e.target.closest('[data-np-mdr-close]')){ mOpen(false); return; }
      var a = e.target.closest('[data-np-acc]');
      if(a){
        var on = a.getAttribute('aria-expanded') !== 'true';
        a.setAttribute('aria-expanded', on ? 'true' : 'false');
        var p = document.getElementById(a.getAttribute('aria-controls')); if(p) p.hidden = !on;
      }
      if(e.target.closest('[data-np-opencart]') && document.querySelector('[data-np-drawer]')){ mdr.classList.remove('on'); document.body.classList.remove('np-lock','np-mopen'); }
    });
    /* keep Tab inside the open drawer */
    mdr.addEventListener('keydown', function(e){
      if(e.key !== 'Tab' || !mdr.classList.contains('on')) return;
      var f = [].slice.call(mdr.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])')).filter(function(x){ return x.offsetParent !== null; });
      if(!f.length) return;
      if(e.shiftKey && document.activeElement === f[0]){ e.preventDefault(); f[f.length-1].focus(); }
      else if(!e.shiftKey && document.activeElement === f[f.length-1]){ e.preventDefault(); f[0].focus(); }
    });
    window.addEventListener('resize', function(){ if(window.innerWidth > 1060 && mdr.classList.contains('on')) { mdr.classList.remove('on'); document.body.classList.remove('np-lock','np-mopen'); } });
  }

  /* ---------------- predictive search ---------------- */
  var qi = hdr.querySelector('[data-np-q]');
  var drop = hdr.querySelector('[data-np-sdrop]');
  var sopen = hdr.querySelector('[data-np-sopen]');
  var tpl = document.getElementById('np-sdrop-empty');
  var cache = {}, ctrl = null, st, active = -1;
  var routes = (NP.routes || {});
  var suggestUrl = routes.predictive || '/search/suggest';
  var searchUrl = routes.search || '/search';

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function norm(s){ return (s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,''); }
  function highlight(root, q){
    var words = norm(q).trim().split(/\s+/).filter(function(w){ return w.length > 0; });
    if(!words.length) return;
    root.querySelectorAll('[data-hl]').forEach(function(el){
      var txt = el.textContent, n = norm(txt), marks = [];
      words.forEach(function(w){ var i = n.indexOf(w); if(i > -1) marks.push([i, i + w.length]); });
      if(!marks.length) return;
      marks.sort(function(a,b){ return a[0]-b[0]; });
      var out = '', pos = 0;
      marks.forEach(function(m){ if(m[0] < pos) return; out += esc(txt.slice(pos, m[0])) + '<mark>' + esc(txt.slice(m[0], m[1])) + '</mark>'; pos = m[1]; });
      el.innerHTML = out + esc(txt.slice(pos));
    });
  }
  function openDrop(){
    if(!drop) return;
    if(cur) openMenu(null);
    hdr.classList.add('sopen'); drop.hidden = false;
    qi.setAttribute('aria-expanded','true'); if(sopen) sopen.setAttribute('aria-expanded','true');
  }
  function closeDrop(){
    if(!drop || drop.hidden) { hdr.classList.remove('sopen'); return; }
    hdr.classList.remove('sopen'); drop.hidden = true; active = -1;
    qi.setAttribute('aria-expanded','false'); if(sopen) sopen.setAttribute('aria-expanded','false');
  }
  function paint(html, q){
    drop.innerHTML = html; active = -1;
    if(q) highlight(drop, q);
  }
  function jsonFallback(q){
    var url = suggestUrl + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,query,article&resources[limit]=6';
    return fetch(url, {headers:{Accept:'application/json'}}).then(function(r){ return r.json(); }).then(function(j){
      var R = (j && j.resources && j.resources.results) || {}, ps = R.products || [], qs = R.queries || [], as = R.articles || [];
      var sq = qs.length ? qs.slice(0,4) : [{text:q+' rackets', url: searchUrl+'?q='+encodeURIComponent(q+' rackets')},{text:q+' bag', url: searchUrl+'?q='+encodeURIComponent(q+' bag')}];
      var lvl = tpl ? (tpl.content.querySelector('.l .sug') || {}).outerHTML || '' : '';
      var h = '<div class="l"><div class="sug"><h4>Suggestions</h4>' + sq.map(function(s){ return '<a href="'+esc(s.url)+'"><svg class="i sm" aria-hidden="true"><use href="#i-search"/></svg><span data-hl>'+esc(s.text)+'</span></a>'; }).join('') + '</div>' + lvl +
        (as.length ? '<div class="sug"><h4>Guides</h4>' + as.slice(0,2).map(function(a){ return '<a href="'+esc(a.url)+'"><svg class="i sm" aria-hidden="true"><use href="#i-arrow"/></svg><span>'+esc(a.title)+'</span></a>'; }).join('') + '</div>' : '') + '</div>';
      h += '<div class="r"><h4>Products</h4>';
      if(ps.length){
        h += '<div class="prods">' + ps.slice(0,5).map(function(p){
          var price = Math.round(parseFloat(p.price) * 100), cmp = Math.round(parseFloat(p.compare_at_price_max || 0) * 100);
          var money = NP.formatMoney ? NP.formatMoney : function(c){ return '£' + (c/100).toFixed(2); };
          return '<a class="sp2" href="'+esc(p.url)+'">' + (p.image ? '<img src="'+esc(p.image)+'&width=128" width="64" height="64" alt="" loading="lazy">' : '<span class="ph0" aria-hidden="true"></span>') +
            '<span><b data-hl>'+esc(p.title)+'</b><span class="mt">'+esc(p.type || '')+'</span></span><span class="pr">'+money(price)+(cmp > price ? '<s>'+money(cmp)+'</s>' : '')+'</span></a>';
        }).join('') + '</div><div class="all"><span style="color:var(--steel)"><span class="kbd">Enter</span> to see everything</span><a href="'+searchUrl+'?q='+encodeURIComponent(q)+'&options%5Bprefix%5D=last">See all results for "'+esc(q)+'" <svg class="i sm" aria-hidden="true"><use href="#i-arrow"/></svg></a></div>';
      } else {
        h += '<div class="none"><b>Nothing matches "'+esc(q)+'"</b><span style="color:var(--steel)">Check the spelling, or try a brand or level.</span></div>';
      }
      return h + '</div>';
    });
  }
  function fetchSuggest(q){
    if(cache[q]) return Promise.resolve(cache[q]);
    if(ctrl) ctrl.abort();
    ctrl = ('AbortController' in window) ? new AbortController() : null;
    var url = suggestUrl + '?q=' + encodeURIComponent(q) + '&resources[type]=product,query,article&resources[limit]=6&resources[limit_scope]=each&section_id=np-predictive-search';
    return fetch(url, ctrl ? {signal: ctrl.signal} : {}).then(function(r){
      if(!r.ok) throw new Error('suggest ' + r.status);
      return r.text();
    }).then(function(txt){
      var doc = new DOMParser().parseFromString(txt, 'text/html');
      var box = doc.getElementById('np-sres');
      if(!box) throw new Error('no section');
      return box.innerHTML;
    }).catch(function(err){
      if(err && err.name === 'AbortError') throw err;
      return jsonFallback(q);
    }).then(function(html){ cache[q] = html; return html; });
  }
  function update(){
    var q = qi.value.trim();
    openDrop();
    if(!q){ paint(tpl ? tpl.innerHTML : ''); return; }
    clearTimeout(st);
    st = setTimeout(function(){
      var r = drop.querySelector('.r'); if(r) r.classList.add('busy');
      fetchSuggest(q).then(function(html){ if(qi.value.trim() === q) paint(html, q); }).catch(function(){});
    }, 160);
  }
  function options(){ return [].slice.call(drop.querySelectorAll('a')).filter(function(a){ return a.offsetParent !== null; }); }
  function move(d){
    var o = options(); if(!o.length) return;
    if(active > -1 && o[active]) o[active].classList.remove('on');
    active = (active + d + o.length) % o.length;
    o[active].classList.add('on'); o[active].scrollIntoView({block:'nearest'});
  }
  if(qi && drop){
    qi.addEventListener('focus', update);
    qi.addEventListener('input', update);
    qi.addEventListener('keydown', function(e){
      if(e.key === 'ArrowDown'){ e.preventDefault(); if(drop.hidden) update(); else move(1); }
      else if(e.key === 'ArrowUp'){ e.preventDefault(); move(-1); }
      else if(e.key === 'Escape'){ closeDrop(); qi.blur(); if(sopen && window.getComputedStyle(sopen).display !== 'none') sopen.focus(); }
      else if(e.key === 'Enter'){
        var o = options();
        if(active > -1 && o[active]){ e.preventDefault(); window.location.href = o[active].href; }
        /* otherwise the form submits to /search?q= */
      }
    });
    if(sopen) sopen.addEventListener('click', function(){
      if(!drop.hidden){ closeDrop(); return; }
      hdr.classList.add('sopen'); qi.focus(); update();
    });
    document.addEventListener('click', function(e){
      if(drop.hidden) return;
      if(e.target.closest('[data-np-sdrop]') || e.target.closest('[data-np-sform]') || e.target.closest('[data-np-sopen]')) return;
      closeDrop();
    });
    drop.addEventListener('focusout', function(e){ if(e.relatedTarget && !hdr.contains(e.relatedTarget)) closeDrop(); });
  }

  /* ---------------- global Escape ---------------- */
  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape') return;
    if(cur){ var b = btnFor(cur); openMenu(null); if(b) b.focus(); }
    if(mdr && mdr.classList.contains('on')) mOpen(false);
  });

  /* ---------------- basket count ---------------- */
  document.addEventListener('np:cart:changed', function(e){
    var c = e.detail; if(!c || typeof c.item_count !== 'number') return;
    document.querySelectorAll('[data-np-bagn]').forEach(function(n){ n.textContent = c.item_count; n.hidden = c.item_count === 0; });
    document.querySelectorAll('[data-np-baglink]').forEach(function(a){ a.setAttribute('aria-label', 'Basket, ' + c.item_count + ' item' + (c.item_count === 1 ? '' : 's')); });
  });
})();


/* Scroll lock for drawers (cart, mobile menu). overflow:hidden on body doesn't stop the page
   scrolling behind a drawer on iOS (Safari, Firefox, Chrome), so pin the body while np-lock is on. */
(function(){
  function init(){
    var b = document.body, h = document.documentElement, y = 0, on = false;
    function set(l){
      if (l === on) return; on = l;
      if (l){
        y = window.pageYOffset || h.scrollTop || 0;
        b.style.position = 'fixed'; b.style.top = (-y) + 'px'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%';
      } else {
        b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = '';
        var sb = h.style.scrollBehavior; h.style.scrollBehavior = 'auto'; window.scrollTo(0, y); h.style.scrollBehavior = sb;
      }
    }
    new MutationObserver(function(){ set(b.classList.contains('np-lock')); }).observe(b, { attributes: true, attributeFilter: ['class'] });
    set(b.classList.contains('np-lock'));
  }
  if (document.body) init(); else document.addEventListener('DOMContentLoaded', init);
})();
